import { TemplateConfig } from '../types';

export const fourSeasonsSpreadConfig: TemplateConfig = {
  id: 'four-seasons-spread',
  name: '{{seasonTerm}}四季牌阵',
  description: '聚焦今年{{seasonName}}这个季度的整体季度运势',
  cardCount: 6,
  specialCategory: 'four-seasons',
  
  fieldDefaults: {
    title: '{{seasonTerm}}四季牌阵',
    customerQuestion: '着重分析在今年{{seasonName}}这个季度内，客户的各方面运势。',
    cardPlaceholders: [
      '请输入第 2 行第 2 张牌',
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 3 张牌',
      '请输入第 3 行第 2 张牌',
      '请输入第 3 行第 1 张牌',
      '请输入第 2 行第 1 张牌'
    ],
    cardInfos: [
      '宫廷人物牌：代表客户在接下来这个季度需要增强或改进的性格',
      '大阿尔卡纳牌：代表客户在接下来这个季度的精神课题与灵性发展',
      '圣杯牌：代表水元素，也就是客户在接下来这个季度的感情、桃花、人际关系方面的发展',
      '权杖牌：代表火元素，也就是客户在接下来这个季度的行动力、做事积极性方面的情况，这部分也会影响到客户这个季度的生活状态，尤其是事业或学业情况',
      '星币牌：代表土元素，也就是客户在接下来这个季度的财运物质和安全感方面的情况，这部分也会与学业或事业以及感情、人际关系有关',
      '宝剑牌：代表风元素，也就是客户在接下来这个季度的计划、思维和沟通表达方面的情况'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#fa8c16',
    backgroundColor: '#fff7e6',
    icon: '🍁'
  }
};
